<template>
  <!-- eslint-disable -->
  <div class="py-4 text-xs max-w-screen-xl large:max-w-screen-large">
    <div class="flex">
      <!-- COLUMN 1 -->
      <div class="w-1/2 mr-2">
        <!-- MAP -->
        <MapSection :data="widgetMapValues" />
        <!-- PIE CHART -->
        <div class="flex mt-4">
          <div 
            class="w-1/2 h-64">
            <!-- PDC -->
            <LoadTrendsCustom
              v-if="loadTrendVisible"
              :data="dc"
              location="PDC"
              :chartData="chartDataAlarms[0]"
              :label="'PENGERANG DATA CENTRE'" />
          </div>
          <div
            class="w-1/2 h-64">
            <!-- THMO -->
            <LoadTrendsCustom
              v-if="loadTrendVisible"
              :data="dc"
              location="THMO"
              :chartData="chartDataAlarms[1]"
              :label="'THMO SERVER ROOM'" />
          </div>
        </div>
      </div>
      <!-- COLUMN 2 -->
      <div class="w-1/2 ml-2">
        <!-- CRAC STATUS -->
          <CRACStatus :alarm-data="alarmDataAc"/>
        <!-- UPS STATUS -->
          <UPSStatus />
      </div>
    </div>
    
  </div>
</template>

<script>
/* eslint-disable */
import MapSection from './MapSection'
import CRACStatus from './CRACStatus'
import UPSStatus from './UPSStatus'
import LoadTrendsCustom from '@/components/Portal/LoadTrendsCustom'
// import { mixin as VueTimers } from 'vue-timers'

export default {
  components: {
    MapSection,
    CRACStatus,
    UPSStatus,
    LoadTrendsCustom
  },
  // mixins: [VueTimers],
  // timers: {
  //   getAndFillChartAlarmData: {
  //     autostart: true,
  //     repeat: true,
  //     immediate: true,
  //     time: 60000
  //   }
  // },
  data() {
    return {
			alarmDataAc: [],
      loadTrendVisible: true,
      widgetMapValues: ['-', '-', '-', '-'], // pdc-temperature, pdc-humidity, thmo-temperature, thmo-humidity
      dc: {
        name: 'TMONE Iskandar Puteri Data Centre (IPDC)',
        label: 'Iskandar Puteri DCd (IPDC)',
        kw: '646Kw',
        position: [1.4352716, 103.5986817],
        pinIcon: '/img/red-pin.png',
      }, 
      chartDataAlarms: [[0, 0, 0], [0, 0, 0]],
      getAndFillChartAlarmDataInterval: null
    }
  },
  mounted() {
		this.fetchCustomAlarm()
    this.getAndFillChartAlarmData(0)
    this.getAndFillChartAlarmData(1)

    this.getAndFillChartAlarmDataInterval = setInterval(() => {
      this.getAndFillChartAlarmData(0)
      this.getAndFillChartAlarmData(1)
			this.fetchCustomAlarm()
    }, 60000);

    this.fetchWidgetMap()
  },
  methods: {
    async fetchWidgetMap() {
      const pdcTemp = this.$axios.get('Dashboard/GetDashboardScreenData?screen=MAINDT')
      const pdcHumid = this.$axios.get('Dashboard/GetDashboardScreenData?screen=MAINDH')
      const thmoTemp = this.$axios.get('Dashboard/GetDashboardScreenData?screen=RACKTEMPPICMO')
      const thmoHumid = this.$axios.get('Dashboard/GetDashboardScreenData?screen=RACKHUMIDPICMO')

      const results = await Promise.allSettled([pdcTemp, pdcHumid, thmoTemp, thmoHumid])

      let widgetMapValues = [0, 0, 0, 0]
      results.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          widgetMapValues[index] = result.value?.data[0]?.AverageCurrent.DecimalVal
        }
      })

      this.widgetMapValues = widgetMapValues
    },
		async fetchCustomAlarm() {
			try {
				const { data: res } = await this.$axios.get('CustomAlarm/DashboardCustomAlarm')
				this.alarmDataAc = res
			} catch (error) {
				console.error(error)	
			}
		},
    async getAndFillChartAlarmData(index) {
      
      const endpoints = [
        'Alarms/GetActiveAlarmsByTypeAndRoom?isDevice=true&room=Pengerang',
        'Alarms/GetActiveAlarmsByTypeAndRoom?isDevice=true&room=PICMO'
      ]

      try {
        const res = await this.$axios.get(endpoints[index])
        const countSeverity = res.data.CountSeverity

        this.chartDataAlarms[index] = [
          countSeverity.CRITICAL,
          countSeverity.WARNING,
          countSeverity.INFORMATIONAL
        ]
        this.loadTrendVisible = false
        setTimeout(() => {
          this.loadTrendVisible = true
        }, 10);
      } catch (err) {
        console.log(err)
      }
    },
    getImgUrl(pic) {
      try {
        return require('@/assets/images/' + pic)
      } catch (e) {
        return ''
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.getAndFillChartAlarmDataInterval)
  }
}
</script>

<style lang="css">
  .bg-custom-1 {
    background-image: linear-gradient(
      to right,
      #e09ce7,
      #d39be9,
      #c59aea,
      #b69aeb,
      #a799eb,
      #93a1f0,
      #7fa8f1,
      #6eaeef,
      #63bbeb,
      #6ac6e3,
      #7ecfd9,
      #97d6d2
    );
  }

  .bg-custom-2 {
    background-image: linear-gradient(
      to right,
      #f89ccf,
      #f995c5,
      #fa8fbb,
      #fa88b0,
      #fa82a5,
      #ff8697,
      #ff8b8a,
      #ff927e,
      #ffa973,
      #ffc26e,
      #f5dc73,
      #e2f686
    );
  }

  .bg-custom-3 {
    background-color: #f7ce68;
    background-image: linear-gradient(62deg, #f7ce68 0%, #e43b62 100%);
  }
  i.el-icon-location {
    color: #f00;
    font-size: 1rem;
  }
  .slick-dots {
    bottom: -25px;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
    top: 10px;
    position: relative;
  }
  .slick-prev::before, .slick-next::before {
    color: #e53e3e !important;
  }
</style>
